module.exports = __webpack_public_path__ + "img/logo.5fe11f36.png";